import React from "react";
import { Link } from 'react-router-dom';

const Join = () => {
  const handleContactUsClick = () => {
    // Example 1: Redirect to a contact page
    // window.location.href = "/contact"; // Uncomment this if you want to redirect

    // Example 2: Scroll to a contact form on the same page
    const contactForm = document.getElementById("contact");
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: "smooth" });
    }

    // Example 3: Open a modal (you need to implement the modal component)
    // setShowModal(true); // Uncomment this if you have a modal state
  };


  return (
    <div className="join-section mb-5 video-background-wrapper">
      <div className="video-cont">
        <video autoPlay muted loop playsInline className="video-background">
          <source src="./images/blocks.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div data-aos="fade-down" data-aos-delay="500" className="container content-overlay">
          <div className="row align-items-center p-sm-4">
            <div className="col-12 py-5">
              <div className="d-flex justify-content-center">
                <div className="py-5 text-center">
                  <button className="btn-gradient mb-3">The Stabolution</button>
                  <h2 className="text-gradient">Join the stablecoin revolution!</h2>
                  <div className="d-flex flex-wrap align-items-center gap-3 mt-4 justify-content-center">
                    <button onClick={handleContactUsClick} className="btn-black">
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Join;